import _sfc_main from "./PopUpH5.vue2.mjs";
/* empty css              */
import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "popup-container" }, [_c("div", { staticClass: "popup-main-header" }, [_c("span", { directives: [{ name: "tap", rawName: "v-tap", value: _setup.handleClose, expression: "handleClose" }], staticClass: "icon-container" }, [_c(_setup.SvgIcon, { staticClass: "close-icon", attrs: { "icon": _setup.ArrowStrokeBackIcon } })], 1), _c("span", { staticClass: "sidebar-title" }, [_vm._v(_vm._s(_vm.title))])]), _c("div", { staticClass: "popup-main-content" }, [_vm._t("sidebarContent")], 2), _c("div", { staticClass: "popup-main-footer" }, [_vm._t("sidebarFooter")], 2)]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "c7ee8fe3"
);
const popup = __component__.exports;
export {
  popup as default
};
